import { createContext } from 'react';
import type { User } from 'firebase/auth';

export interface AuthContextType {
  user: User | null;
  loading: boolean;
  signup: (
    email: string,
    password: string,
    displayName?: string,
    consent?: import('@/services/consentService').SignupConsent
  ) => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  loginWithGoogle: (
    consent?: import('@/services/consentService').SignupConsent
  ) => Promise<void>;
  loginWithApple: (
    consent?: import('@/services/consentService').SignupConsent
  ) => Promise<void>;
  logout: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
